<sidebar-component
    *ngIf='!location_.isCurrentPathEqualTo("/login")'
></sidebar-component>
<div
    [class]="(location_.isCurrentPathEqualTo('/login'))  ? 'login' : 'content'"
>
    <router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
</div>
